import {
  SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST,
} from 'api/actionTypes';

export default async function getPartnerDraftConfigurationList({ state, apiClient }, { refresh } = {}) {
  const statePath = ['leases', 'configurationsList'];
  if (!refresh && state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST,
    state: state,
    onSuccess(leaseDraftConfigurationList) {
      state.set(statePath, leaseDraftConfigurationList);
    },
  });
}
